import React from 'react';

// Renders text that WRAPS onto multiple lines instead of being truncated.
// Counterpart to <LongText/> (which truncates with an ellipsis/tooltip). Use it
// in DataTable column `data` renderers where long values (e.g. survey question /
// answer texts) should break across lines rather than be cut off.
const WrapText = ({ text, className = '' }) => (
  <span className={className} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
    {text}
  </span>
);

export default WrapText;
